module.exports = __webpack_public_path__ + "static/media/document.2541711e.svg";